export enum CollateralErrorType {
    limitInsufficient = 'limitInsufficient',
    limitTypeIncorrect = 'limitTypeIncorrect',
    limitValuationIncorrect = 'limitValuationIncorrect',
    deductibleValueInsufficient = 'deductibleValueInsufficient',
    deductiblePercentInsufficient = 'deductiblePercentInsufficient',
    coverageTypeExpired = 'coverageTypeExpired',
    collateralNotProvided = 'collateralNotProvided',
    fieldValueMissing = 'fieldValueMissing',
}
